import { t } from 'ttag';

const CATEGORY = {
  INTRODUCTION: t`Introduction`,
  HR_CHART: t`Read and manage HR chart`,
  ECG_CHART: t`Read and manage ECG chart`,
  EVENT: t`Select and view an event in event list`,
};

export default CATEGORY;
